import React from "react";
import classNames from "classnames";
import {
  websiteBuilderGenerateIconDesignStyles,
  websiteBuilderFindIconAsset,
  WEBSITE_BUILDER_MISSING_ICON_ASSET_SVG,
  IWebsiteBuilderIcon,
} from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderIcon";
import { useAppSelector } from "hooks/redux";

interface IWebsiteBuilderIconViewProps {
  node: IWebsiteBuilderIcon;
}

export function WebsiteBuilderIconView(props: IWebsiteBuilderIconViewProps) {
  const { node } = props;

  const iconAssets = useAppSelector(store => store.websiteBuilderStore.editor.iconAssets);

  const settings = node.element.settings;
  const designStyles = websiteBuilderGenerateIconDesignStyles(settings);

  const iconAsset = websiteBuilderFindIconAsset(iconAssets, settings.assetIdentity);

  const svg = iconAsset?.svg ?? (settings.assetIdentity != null ? WEBSITE_BUILDER_MISSING_ICON_ASSET_SVG : null);

  return (
    <div className={designStyles.containerClassName}>
      <div
        className={classNames(designStyles.className, "editor-icon")}
        style={designStyles.styleProperties}
        dangerouslySetInnerHTML={{
          __html: svg,
        }}
      />
    </div>
  );
}
